var render = function render(){var _vm=this,_c=_vm._self._c;return _c('advanced-json-editor',{attrs:{"json":this.form.settings.fields,"height":640},on:{"update:json":function($event){return _vm.$set(this.form.settings, "fields", $event)},"error":_vm.onError,"updated":_vm.onUpdated}})
}
var staticRenderFns = []

export { render, staticRenderFns }